import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";

const CATEGORIES = ["All", "Classroom Play", "Creative Art", "Outdoor Fun"];

const PHOTOS = [
  { src: "https://images.unsplash.com/photo-1777056481869-feac70afe522?crop=entropy&cs=srgb&fm=jpg&q=85", cat: "Classroom Play", alt: "Toddlers learning together in the classroom", tall: false },
  { src: "https://images.unsplash.com/photo-1560421683-6856ea585c78?crop=entropy&cs=srgb&fm=jpg&q=85", cat: "Creative Art", alt: "Child absorbed in a painting activity", tall: true },
  { src: "https://images.unsplash.com/photo-1599376672737-bd66af54c8f5?crop=entropy&cs=srgb&fm=jpg&q=85", cat: "Outdoor Fun", alt: "Children playing in the outdoor play zone", tall: false },
  { src: "https://images.unsplash.com/photo-1607211851821-8be3cd6146f0?crop=entropy&cs=srgb&fm=jpg&q=85", cat: "Creative Art", alt: "Finger painting with bright colours", tall: true },
  { src: "https://images.unsplash.com/photo-1761208663763-c4d30657c910?crop=entropy&cs=srgb&fm=jpg&q=85", cat: "Classroom Play", alt: "Playing with toys and building blocks", tall: false },
  { src: "https://images.unsplash.com/photo-1630139026564-4a2bf5670879?crop=entropy&cs=srgb&fm=jpg&q=85", cat: "Outdoor Fun", alt: "Running and playing outside", tall: false },
];

export const Activities = () => {
  const [cat, setCat] = useState("All");
  const shown = cat === "All" ? PHOTOS : PHOTOS.filter((p) => p.cat === cat);

  return (
    <section id="activities" data-testid="activities-section" className="relative py-24 lg:py-32 bg-mint/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <span className="inline-block text-xs font-bold tracking-[0.24em] uppercase text-peach mb-4">
            Life at Kiwi Kids
          </span>
          <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ink">
            Moments of joy,{" "}
            <em className="font-quote italic font-medium text-sage">made daily</em>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-9 flex flex-wrap gap-2.5">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`activities-filter-${c.toLowerCase().replace(/ /g, "-")}`}
                onClick={() => setCat(c)}
                className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${
                  cat === c
                    ? "bg-ink text-cream shadow-md"
                    : "bg-white text-ink/60 hover:text-ink border border-ink/8"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </Reveal>

        <motion.div layout className="mt-10 columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          <AnimatePresence mode="popLayout">
            {shown.map((p) => (
              <motion.figure
                layout
                key={p.src}
                initial={{ opacity: 0, scale: 0.92 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.92 }}
                transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                className="mb-6 break-inside-avoid group relative rounded-[1.75rem] overflow-hidden shadow-md"
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                    p.tall ? "h-96" : "h-64"
                  }`}
                />
                <figcaption className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-ink/70 to-transparent text-cream text-sm font-semibold translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  {p.alt}
                </figcaption>
              </motion.figure>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
